import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'airbnb': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAirbnb" */
        '@fortawesome/free-brands-svg-icons/faAirbnb'
    ),
    'angellist': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAngellist" */
        '@fortawesome/free-brands-svg-icons/faAngellist'
    ),
    'asymmetrik': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAsymmetrik" */
        '@fortawesome/free-brands-svg-icons/faAsymmetrik'
    ),
    'buffer': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBuffer" */
        '@fortawesome/free-brands-svg-icons/faBuffer'
    ),
    'buromobelexperte': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBuromobelexperte" */
        '@fortawesome/free-brands-svg-icons/faBuromobelexperte'
    ),
    'cc-stripe': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCcStripe" */
        '@fortawesome/free-brands-svg-icons/faCcStripe'
    ),
    'creative-commons-sampling': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCreativeCommonsSampling" */
        '@fortawesome/free-brands-svg-icons/faCreativeCommonsSampling'
    ),
    'earlybirds': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faEarlybirds" */
        '@fortawesome/free-brands-svg-icons/faEarlybirds'
    ),
    'facebook-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareFacebook" */
        '@fortawesome/free-brands-svg-icons/faSquareFacebook'
    ),
    'figma': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFigma" */
        '@fortawesome/free-brands-svg-icons/faFigma'
    ),
    'gg': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGg" */
        '@fortawesome/free-brands-svg-icons/faGg'
    ),
    'google-plus': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGooglePlus" */
        '@fortawesome/free-brands-svg-icons/faGooglePlus'
    ),
    'google-plus-g': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGooglePlusG" */
        '@fortawesome/free-brands-svg-icons/faGooglePlusG'
    ),
    'imdb': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faImdb" */
        '@fortawesome/free-brands-svg-icons/faImdb'
    ),
    'letterboxd': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faLetterboxd" */
        '@fortawesome/free-brands-svg-icons/faLetterboxd'
    ),
    'megaport': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faMegaport" */
        '@fortawesome/free-brands-svg-icons/faMegaport'
    ),
    'ns8': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faNs8" */
        '@fortawesome/free-brands-svg-icons/faNs8'
    ),
    'old-republic': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faOldRepublic" */
        '@fortawesome/free-brands-svg-icons/faOldRepublic'
    ),
    'palfed': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faPalfed" */
        '@fortawesome/free-brands-svg-icons/faPalfed'
    ),
    'pix': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faPix" */
        '@fortawesome/free-brands-svg-icons/faPix'
    ),
    'reacteurope': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faReacteurope" */
        '@fortawesome/free-brands-svg-icons/faReacteurope'
    ),
    'rust': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faRust" */
        '@fortawesome/free-brands-svg-icons/faRust'
    ),
    'sellsy': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSellsy" */
        '@fortawesome/free-brands-svg-icons/faSellsy'
    ),
    'servicestack': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faServicestack" */
        '@fortawesome/free-brands-svg-icons/faServicestack'
    ),
    'square-instagram': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareInstagram" */
        '@fortawesome/free-brands-svg-icons/faSquareInstagram'
    ),
    'square-reddit': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareReddit" */
        '@fortawesome/free-brands-svg-icons/faSquareReddit'
    ),
    'square-viadeo': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faViadeoSquare" */
        '@fortawesome/free-brands-svg-icons/faViadeoSquare'
    ),
    'steam': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSteam" */
        '@fortawesome/free-brands-svg-icons/faSteam'
    ),
    'stumbleupon': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faStumbleupon" */
        '@fortawesome/free-brands-svg-icons/faStumbleupon'
    ),
    'symfony': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSymfony" */
        '@fortawesome/free-brands-svg-icons/faSymfony'
    ),
    'the-red-yeti': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faTheRedYeti" */
        '@fortawesome/free-brands-svg-icons/faTheRedYeti'
    ),
    'think-peaks': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faThinkPeaks" */
        '@fortawesome/free-brands-svg-icons/faThinkPeaks'
    ),
    'ups': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faUps" */
        '@fortawesome/free-brands-svg-icons/faUps'
    ),
    'ussunnah': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faUssunnah" */
        '@fortawesome/free-brands-svg-icons/faUssunnah'
    ),
    'vimeo-v': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faVimeoV" */
        '@fortawesome/free-brands-svg-icons/faVimeoV'
    ),
    'weibo': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWeibo" */
        '@fortawesome/free-brands-svg-icons/faWeibo'
    ),
    'y-combinator': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faYCombinator" */
        '@fortawesome/free-brands-svg-icons/faYCombinator'
    ),
    'yelp': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faYelp" */
        '@fortawesome/free-brands-svg-icons/faYelp'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>